export default __webpack_public_path__ + "/dist/images/how-to-help.png";